var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"svgWrapper",staticClass:"the-interactive-svg",class:{
    'the-interactive-svg--disabled': _vm.disabled,
  },domProps:{"innerHTML":_vm._s(_vm.svgInnerHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }